export const SSSUITE_API_URL = process.env.REACT_APP_SSSUITE_API_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.safesendwebsites.com";

export const apiGroup = {
    login:  'Login',
    Delivered: 'Delivered',
    In_Process: 'In Process',
    Recycle_Bin: 'Recycle Bin',
    Returns: 'Returns',
    Status: 'Status',
    ReturnStatus: 'Return Status',
    Grouped_Returns: 'Grouped Returns',
    Upload: 'Upload',
    Archived: 'Archived',
    Recycle_Bin_report: 'Recycle Bin Report',
    Draft_Report: 'Draft Report',
    Delivered_Report: 'Delivered Report',
    Archive_Report: 'Archive Report',
    Signature_Upload: 'Signature Upload',
    Organizer_Archived: 'Archived Organizer',
    Organizer_Delivered: 'Delivered Organizer',
    Organizer_In_Process: 'In Process Organizer',
    Organizer_Status: 'Organizer Status',
    Organizer_Recycle_Bin: 'Recycled Organizer',
    Organizer_UploadOrganizer:'Upload Organizer',
    SSE_DRL_Document: 'Download Drl Document',
    SSR_WEBHOOKS: 'Download Esign Document',
    Safesend_Exchange_ComposeMessage: 'Compose Message',
    Safesend_Exchange_DocumentRequest: 'Document Request',
    Safesend_Exchange_DocumentRequestTemplate: 'Document Request Template',
    Client_Management: 'Client Management',
    office_location: 'Office Location',
    user_management: 'User Management',
    Delivered_Gather: 'Delivered Gather',
    In_Process_Gather: 'In Process Gather',
}

export const product = {
    Guides: 'Guides',
    SafeSend_Suite: 'SafeSend Suite',
    SafeSend_Returns: 'SafeSend Returns',
    SafeSend_Organizer: 'SafeSend Organizers',
    SafeSend_Signatures: 'SafeSend Signatures',
    SafeSend_Exchange: 'SafeSend Exchange',
    SafeSend_Gather: 'SafeSend Gather',
}

export const menuItem = {
    clientInformationChange : 'Client Information Change'
}